import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ProductService } from '../../_services/_masters/product.service';
import { ConsignorService } from '../../_services/_masters/consignor.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import { SelectablesService } from '../../selectables.service';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;

class ProductForm {
	product_name:string;
	packing : string;
	branch: string;
}

@Component({
	selector: 'app-product',
	templateUrl: './product.component.html',
	styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

	productForm : FormGroup;
	modalProductForm : FormGroup;
	check_branch: boolean = true;
	modalData : any;
	consignors: any[] = [];
	selected_branch="";

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	product_form: ProductForm[] = [];

	stations : string[] = [];
	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;
	url = environment.url;
	query : any = null;
	response : any = null;

	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	constructor( 
		private productService : ProductService,
		private selectBranchService : SelectablesService,
		private selectConsignorService : ConsignorService,
		private http: Http) 
	{ }

	ngOnInit() {
		this.productForm = new FormGroup({
			'product_name': new FormControl(null , Validators.required),
			'consignor_name': new FormControl(null , Validators.required),
			'packing': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
		});
		
		this.modalProductForm = new FormGroup({
			'product_name': new FormControl(null , Validators.required),
			'consignor_name': new FormControl(null , Validators.required),
			'packing': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

		this.http.get( this.url +'/masters/product/all')
		// this.http.get('http://backendtransport.iogreen.in/masters/product/all')
			.map(this.extractData)
			.subscribe(forms => {
				this.product_form = forms;
				console.log(this.product_form);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});
			

		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.getConsignorBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.productForm.get('branch').setValue(temp['branch']);
				this.stations.push(temp['branch']);
				this.selected_branch=temp['branch'];
				this.getConsignorBySelectedBranch(temp['branch']);
				this.check_branch = true;
			}
		}
	}
	getBranch()
	{
		this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
	}
	getConsignor()
	{
		this.selectConsignorService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
	}
	getConsignorBySelectedBranch(branch)
	{
		if(this.check_branch==false)
			this.selected_branch=branch;
		this.consignors=[];
		this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
	}
	getProductBySelectedBranchAndClient(client)
	{
		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/masters/product/get/branchandclient/'+this.selected_branch+'/'+client)
					.map(this.extractData)
					.subscribe(forms => {
					this.product_form = forms;
					console.log(this.product_form);
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});
	}
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		console.log("info");
		console.log(info);
		console.log((info[1]).replace("&amp;", '&'));
		console.log(info[0]);
		this.productService.getProductFormWith((info[1]).replace("&amp;", '&') ,info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalProductForm.patchValue({
				"product_name": this.modalData[0].product_name,
				'consignor_name': this.modalData[0].consignor_name,
				'branch': this.modalData[0].branch,
				"packing": this.modalData[0].packing
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		console.log(this.productForm.value);
		this.productService.addNewProduct(this.productForm.value)
		.subscribe(response => 
		{
			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/masters/product/all')
						.map(this.extractData)
						.subscribe(forms => {
						this.product_form = forms;
						console.log(this.product_form);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page!', 'error');
			}
		});
	};

	updateProduct(){
		console.log(this.modalProductForm.value);
		console.log(this.modalData);

		this.query={
			"product_oid" : this.modalData[0]._id,
			"product_data" : this.modalProductForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/product/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Product Updated Successfully'){
					swal(
						'Success',
						'Product Form Updated Successfully',
						'success'
					);

					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
						dtInstance.destroy();
						this.http.get(this.url + '/masters/product/all')
							.map(this.extractData)
							.subscribe(forms => {
							this.product_form = forms;
							console.log(this.product_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
					});
				}

				if (this.response.message === 'Product Information not Changed'){
					swal(
						'Info',
						'Product information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};

	// DELETE PRODUCT
	deleteProduct(){
		this.query={
			"product_id" : this.modalData[0]._id.$oid,
			"branch": this.modalData[0].branch,
			"consignor_name": this.modalData[0].consignor_name
		}

		console.log(this.query);

		swal({
			title: 'Are you sure?',
			text: 'You want to delete Product',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
				this.http.post(this.url + '/masters/product/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Product has been deleted.','success');

							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
							{
								dtInstance.destroy();
								this.http.get(this.url + '/masters/product/all')
									.map(this.extractData)
									.subscribe(forms => 
									{
										this.product_form = forms;
										console.log(this.product_form);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
							});
							
							$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Product is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
		})
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/product/product.component.ts